<template>
    <div class="c-open-positions-block">
        <Row>
            <Column :md="12">
                <Heading noMarginTop class="u-add-colored-period" v-if="title">{{title}}</Heading>
                <p class="c-open-positions-block__intro" v-if="intro">{{intro}}</p>
            </Column>
        </Row>

        <Row class="c-open-positions-block__categories">
            <Column :xs="11" :sm="5" :md="5">
                <Dropdown v-model="selectedCountry" :options="countryList" placeholder="Company" @input="updateData" />
            </Column>
            <Column :xs="1" class="col-no-gutter">
                <Button buttonStyle="no-style" icon='cross' class="c-clear-button" v-if="selectedCountry" @click.native="reset('country')"></Button>
            </Column>

            <Column :xs="11" :sm="5" :md="5">
                <Dropdown v-model="selectedOffice" :options="filteredOfficeList" placeholder="Office" @input="updateData" />
            </Column>
            <Column :xs="1" class="col-no-gutter">
                <Button buttonStyle="no-style" icon='cross' class="c-clear-button" v-if="selectedOffice" @click.native="reset('office')"></Button>
            </Column>
        </Row>

        <Row class="c-vacancy-table-header">
            <Column :xs="12" :sm="10">
                <Button buttonStyle="no-style" icon="toggle_sort" @click.native="sortyByTitle()">
                    {{getLabel('vacancyPage', 'jobTitleText')}}
                </Button>
            </Column>
            <Column :sm="6">
                <Button buttonStyle="no-style" icon="toggle_sort" @click.native="sortByCompany()">
                    Company
                </Button>
            </Column>
            <Column :xs="12" :sm="6">
                <Button buttonStyle="no-style" icon="toggle_sort" @click.native="sortByLocation()">
                    {{getLabel('vacancyPage', 'locationHeadingText')}}
                </Button>
            </Column>
        </Row>
        <List :items="vacancyList" disableUrl>
            <template v-slot:default="{item}" :url="'/'">
                <Row class="c-open-positions-block__vacancy">
                    <Column :sm="10" class="c-open-positions-block__vacancy__col1">
                        <span class="u-block u-display-sm-down c-open-positions-block__vacancy__country@sm">{{item.country}}</span>
                        <span class="u-block c-open-positions-block__vacancy__title">{{item.title}}</span>
                    </Column>
                    <Column :sm="6" class="u-hidden-xs">
                        <span>{{ item.departmentLabel }}</span>
                    </Column>
                    <Column :sm="6" class="u-display-md-up">
                        <span>{{item.location.name}}</span>
                    </Column>
                    <Column :sm="2" class="text-right">
                        <Anchor isFancy :href="detailedBaseUrl + '?id=' + item.id">{{getLabel('global', 'readMore')}}</Anchor>
                    </Column>
                </Row>
            </template>
        </List>


    </div>
</template>

<script>
import List from '@/Scripts/components/molecules/List.vue';
import Dropdown from '@/Scripts/components/atoms/Dropdown.vue';
import Icon from '@/Scripts/components/atoms/Icon.vue';
import api from '@/Scripts/api/api';

export default {
    props: ['intro', 'title', 'vacancyData', 'detailedBaseUrl'],
    components: {
        List,
        Dropdown,
        Icon
    },
    computed: {
        filteredOfficeList() {
            if (!this.selectedOffice) {
                return this.officeList;
            }
            return this.officeList;
            //return this.listB.filter(item => item.categoryId === parseInt(this.selectedA));
        }
    },
    methods: {
        updateData: function () {
            let params = {
                ...(this.selectedCountry.code && {
                    department: this.selectedCountry.code
                }),
                ...(this.selectedOffice.code && {
                    office: this.selectedOffice.code
                })
            };

            api.getVacanciestListData(params).then(response => {
                let newList = JSON.parse(response.data);
                this.vacancyList = newList;

                this.countryList = this.vacancyData.departments.map(c => {
                    return {
                        label: c.label,
                        code: c.id
                    };
                });
                this.officeList = this.vacancyData.offices.filter(c => c.parentId === this.selectedCountry.code).map(c => {
                    return {
                        label: c.label,
                        code: c.id,
                        parent: c.parentId
                    };
                });
            });
        },
        reset: function (type) {
            if (type === 'country') {
                this.selectedCountry = '';
            }

            if (type === 'office') {
                this.selectedOffice = '';
            }

            this.updateData();
        },


        sortTitle: function (x,y) {
            const xTitle = x.title.toLowerCase();
            const yTitle = y.title.toLowerCase();
            if (xTitle < yTitle) {
                return -1;
            }
            if (xTitle > yTitle) {
                return 1;
            }
            return 0;
        },

        sortyByTitle: function () {
            const vacancies = this.vacancyList;
            if (this.vacancyListSort.title === 'DESC') {
                vacancies.sort(this.sortTitle);
                this.vacancyListSort.title = 'ASC';
                return;
            }

            if (this.vacancyListSort.title === 'ASC') {
                vacancies.sort(this.sortTitle); // Make sure it's sorted by alphabet before reverse the array
                this.vacancyList = vacancies.reverse();
                this.vacancyListSort.title = 'DESC';
                return;
            }
        },

        sortCompany: function (x, y) {
            const xCommpany = x.departmentLabel.toLowerCase();
            const yCompany = y.departmentLabel.toLowerCase();
            if (xCommpany < yCompany) {
                return -1;
            }
            if (xCommpany > yCompany) {
                return 1;
            }
            return 0;
        },

        sortByCompany: function () {
            const vacancies = this.vacancyList;
            if (this.vacancyListSort.company === 'DESC') {
                vacancies.sort(this.sortCompany);
                this.vacancyListSort.company = 'ASC';
                return;
            }

            if (this.vacancyListSort.company === 'ASC') {
                vacancies.sort(this.sortCompany); // Make sure it's sorted by alphabet before reverse the array
                this.vacancyList = vacancies.reverse();
                this.vacancyListSort.company = 'DESC';
                return;
            }
        },

        sortLocation: function (x,y) {
            const xLocation = x.location.name.toLowerCase();
            const yLocation = y.location.name.toLowerCase();
            if (xLocation < yLocation) {
                return -1;
            }
            if (xLocation > yLocation) {
                return 1;
            }
            return 0;
        },

        sortByLocation: function () {
            const vacancies = this.vacancyList;

            if (this.vacancyListSort.location === 'DESC') {
                vacancies.sort(this.sortLocation);
                this.vacancyListSort.location = 'ASC';
                return;
            }

            if (this.vacancyListSort.location === 'ASC') {
                vacancies.sort(this.sortLocation); // Make sure it's sorted by alphabet before reverse the array
                this.vacancyList = vacancies.reverse();
                this.vacancyListSort.location = 'DESC';
                return;
            }

        }
    },
    data: function () {
        return {
            vacancyList: this.vacancyData.jobs,
            vacancyListSort: {
                title: 'ASC',
                company: 'ASC',
                location: 'ASC'
            },
            selectedCountry: '',
            selectedOffice: '',
            countryList: this.vacancyData.departments.map(c => {
                return {
                    label: c.label,
                    code: c.id
                };
            }),
            officeList: this.vacancyData.offices.map(c => {
                return {
                    label: c.label,
                    code: c.id
                };
            })
        };
    }
};
</script>

<style lang="scss">
.c-open-positions-block {
    a:hover {
        text-decoration: none;
    }
    &__intro {
        margin-bottom: 4rem;
    }
    &__categories {
        margin-bottom: 5rem;

        .o-col {
            margin-bottom: 1rem;
        }
    }
    &__vacancy {
        align-items: center;

        &__col1 {
            position: relative;
        }
        &__title {
            font-size: 24px;

            @include media-md {
                font-size: 16px;
            }
        }
        &__country\@sm {
            font-size: 14px;
            color: $gray;
            position: absolute;
            top: -20px;
        }
        &__icon\@sm {
            height: 1.2em;
            width: 1.2em;

            @include media-md {
                display: none;
            }
        }
        &__icon\@md {
            display: none;
            @include media-md {
                display: block;
            }
        }

        .text-right {
            text-align: right;
        }
    }
    .c-list__item {
        &:first-of-type {
            .c-list__item-wrapper {
                @include media-md {
                    border-top: 1px solid $gray !important;
                }
            }
        }
        &-wrapper {
            border: none !important;
            padding-top: 2rem;
            padding-bottom: 2rem;
            @include media-md {
                border-bottom: 1px solid $gray !important;
                padding-top: 1rem;
                padding-bottom: 1rem;
            }
        }
        &:nth-child(odd) {
            z-index: 1;
            position: relative;
            &:before {
                content: "";
                background: white;
                position: absolute;
                width: 200vw;
                top: -1px;
                height: 100%;
                left: -100vw;
                right: 0;
                z-index: -1;
            }
            @include media-md {
                &:before {
                    content: none;
                }
            }
        }
    }
}

.c-clear-button {
    margin-top: 0.3rem;
}

.c-vacancy-table-header {
    padding: 1rem 0;
}
</style>
